// extracted by mini-css-extract-plugin
export default {"routeContainer":"AnimatedRoutes_routeContainer__7yW9P","page":"AnimatedRoutes_page__JeNEt"};